import { useQuery } from '@tanstack/react-query';
import fetchData from '../fetcher';
import { MyOrganizationResponse } from './types';
import { useMyOgnizationStore } from '@/store';

export const fetchMyOrganizations = async () => {
  const response = await fetchData<MyOrganizationResponse>('/iam/v4/iam/organizations/my', {
    method: 'GET',
    credentials: 'include',
  });
  if (response.isSuccess !== false) {
    useMyOgnizationStore.getState().setOgnization({ organizations: response.organizations ?? [] });
  }
  return response;
};

export const useMyOgnization = () => {
  const { data, isSuccess, isEnabled, isError, isLoading } = useQuery({
    queryKey: ['my-ognization'],
    queryFn: fetchMyOrganizations,
  });

  return { data, isSuccess, isEnabled, isError, isLoading };
};
